import { action } from "mobx";

const createSimpleSetter = (store, key) =>
  action(value => {
    store[key] = value;
  });

export const createMutations = store => ({
  setIsLoadingSetup: createSimpleSetter(store, "isLoadingSetup"),
  setIsSavingStep:   createSimpleSetter(store, "isSavingStep"),
  setError:          createSimpleSetter(store, "error"),
  setHasFetched:     createSimpleSetter(store, "hasFetched"),

  setSetupStatus: action(data => {
    if (typeof data.requiresOnboarding === "boolean") {
      store.requiresOnboarding = data.requiresOnboarding;
    }
    if (data.bookingUrl) {
      store.bookingUrl = data.bookingUrl;
    }
    if (data.stepStatus && typeof data.stepStatus === "object") {
      Object.keys(data.stepStatus).forEach(key => {
        if (key in store.stepStatus) {
          store.stepStatus[key] = { ...store.stepStatus[key], ...data.stepStatus[key] };
        }
      });
    }
    if (data.optionalStepStatus && typeof data.optionalStepStatus === "object") {
      Object.keys(data.optionalStepStatus).forEach(key => {
        if (key in store.optionalStepStatus) {
          store.optionalStepStatus[key] = { ...store.optionalStepStatus[key], ...data.optionalStepStatus[key] };
        }
      });
    }
  }),

  setStepEntry: action((stepKey, entry) => {
    if (stepKey in store.stepStatus) {
      store.stepStatus[stepKey] = { ...store.stepStatus[stepKey], ...entry };
    } else if (stepKey in store.optionalStepStatus) {
      store.optionalStepStatus[stepKey] = { ...store.optionalStepStatus[stepKey], ...entry };
    } else {
      console.warn(`WelcomeDashboardStore.setStepEntry: unknown key "${stepKey}"`);
    }
  }),
});
